export default __webpack_public_path__ + "static/media/placeholder.816ca9d2.png";